// Traduce errores crudos de Supabase (PostgREST/Postgres) a mensajes aptos
// para mostrar al usuario final. Antes de este helper, algunas vistas
// mostraban `error.message` tal cual llega del backend (ej. "duplicate key
// value violates unique constraint \"categoria_empresa_id_slug_key\"") —
// técnicamente correcto pero inconsistente con el resto de la UI y con una
// fuga menor de detalles de esquema que el usuario no necesita ver.
//
// No reemplaza la validación de UI existente (esSlugValido, esCorreoValido,
// etc.) — esto es específicamente para errores que solo el servidor puede
// detectar (unicidad, límites de plan) y que sí requieren feedback.

/**
 * @param {{ code?: string, message?: string } | null | undefined} error
 * @param {string} [generico] Mensaje de reserva si el error no es reconocido.
 * @returns {string | null} `null` si no hay error.
 */
export function mensajeErrorAmigable(error, generico = 'Ocurrió un error. Intenta de nuevo.') {
  if (!error) return null;

  // 23505 = unique_violation (Postgres) — típicamente slug/subdominio duplicado.
  if (error.code === '23505') {
    return 'Ya existe un registro con ese mismo valor (revisa que el nombre o el slug no estén repetidos).';
  }

  // P0001 = raise exception genérico de negocio (ver ADR-0007: límites de
  // plan). Estos mensajes ya se redactan pensando en el usuario final desde
  // la propia función SQL, así que se muestran tal cual.
  if (error.code === 'P0001') {
    return error.message ?? generico;
  }

  return generico;
}
